<template>
  <div>
    <span v-if="classes[status]" :class="`nowrap label ${classes[status].class}`">{{ classes[status].label || status }}</span>
  </div>
</template>

<script>

export default {
  name: 'Status',
  props: ['status'],
  data () {
    return {
      classes: {
        Requested: { class: 'label-orange' },
        Accepted: { class: 'label-warning' },
        InProgress: { class: 'label-cyan', label: 'In Progress' },
        Completed: { class: 'label-dark-green' },
        Rejected: { class: 'label-danger' },
        Pending: { class: 'label-danger' },
        Approved: { class: 'label-dark-green' }
      }
    }
  }
}
</script>

<style scoped>
</style>
